<template>
	<div>
		<div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案采集</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>原始凭证</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- <el-divider></el-divider> -->

		<div class="container">
			<el-tabs v-model="sourceVoucherTabs" style="height: 100%;">
				<el-tab-pane label="发票影像上传" name="1">
					<div class="el-upload__tip" style="color: #909399;font-size: 14px;">支持本地导入多种原始凭证，平台会自动识别凭证类型以及凭证信息。</div>
					<div class="el-upload__tip" style="color: #909399;font-size: 14px;">包括增值税专普票、定额发票、过路费发票、出租车发票、火车票、航空运输电子客票行程单、机动车销售统一发票。</div>
					<div class="el-upload__tip" style="color: #909399;font-size: 14px;">文件后缀类型包括： JPG/PNG以及包含前述后缀的ZIP文件。</div>

					<div class="m-bottom-border" style="padding: 10px 0px;">
						<div style="display: flex;">
							<div style="display: flex;">
								<label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体</label>
								<el-select v-model="invCompanyName" placeholder="请选择" style="width: 100%;margin-right: 30px;">
									<el-option
										v-for="item in invCompanyData"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div style="margin-right: 15px;">
								<!-- <el-form :model="invUploadForm" ref="invUploadForm"> -->
									<el-input  v-model="invUploadForm.invoiceUploadFileName"  placeholder="请选择文件" prefix-icon="el-icon-document" clearable style="width: 100%;"></el-input>
								<!-- </el-form> -->
							</div>
							<div>
								<el-upload class="upload-demo" ref="invUpload" :action="originalVoucherUploadUrl" :show-file-list="false" :on-change="invUploadFileChange" :auto-upload="false" :on-error="fileUploadError" :on-success="fileUploadSuccess" :data="uploadData">
									<el-button slot="trigger" plain>选择文件</el-button>
									<el-button size="small" type="primary" @click="invUploadClickFun" style="margin-left: 10px;width: 80px;" :disabled="disabledInvUploadBtn">上传</el-button>
								</el-upload>
							</div>
						</div>
					</div>
					<el-row type="flex" style="padding: 10px 0px;" justify="space-between">
						<el-col :span="2">
							<el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
						</el-col>
						<el-col :span="6"  style="text-align: right;">
							<el-input v-model="invoiceUploadSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
						</el-col>
					</el-row>
					<div>
						<el-table :data="invoiceUploadTableData" ref="invoiceUploadTable" border stripe class="table" height="480px" @row-click="(row) => clickRowByChecked('invoiceUploadTable', row)">
							<el-table-column type="selection" width="55" align="center"></el-table-column>
							<el-table-column prop="id" v-if="show == true"></el-table-column>
							<el-table-column prop="batchNo" label="批次号" sortable></el-table-column>
							<el-table-column prop="companyName" label="所属实体"></el-table-column>
							<el-table-column prop="fileName" label="原文档名称" sortable></el-table-column>
							<el-table-column prop="importWay" label="导入方式" width="150" :formatter="this.formatImportWay" sortable></el-table-column>
							<el-table-column prop="totalCount" label="文件总数" width="150" sortable></el-table-column>
							<el-table-column prop="successCount" label="上传成功数" width="150" sortable>
								<template slot-scope="scope">
									<el-link type="primary" @click="viewOriVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
								</template>
							</el-table-column>
							<el-table-column prop="failedCount" label="上传失败数" width="150" sortable></el-table-column>
							<el-table-column prop="message" label="失败详情" width="150" sortable>
								<template slot-scope="scope">
									<div v-if="scope.row.message && scope.row.message.length > 0">
										<el-link :href="downloadImportLogUrl + scope.row.id + '&' + token" :underline="false" type="primary" >下载日志</el-link>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="importTime" label="上传时间" sortable :formatter="(row, column, cellValue, index) => timestampSecondFormatter(cellValue)"></el-table-column>
							<el-table-column prop="operator" label="操作人" width="150" sortable></el-table-column>
						</el-table>
						<div class="pagination">
							<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="invpwm.page"
								:page-size="invpwm.limit"
								:page-sizes="invpwm.limits"
								layout="total, sizes, prev, pager, next, jumper"
								:total="invpwm.count">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="电票上传" name="2">
					<div style="color: #909399;">支持从本地导入电票原件，文件后缀类型包括：PDF/OFD以及包含前述后缀的ZIP文件。</div>
					<div class="m-bottom-border">
						<div style="display: flex;padding: 10px 0px;" >
							<div style="display: flex;">
								<label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体</label>
								<el-select v-model="einvCompanyName" placeholder="请选择" style="width: 100%;margin-right: 30px;">
									<el-option
										v-for="item in einvCompanyData"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div style="margin-right: 15px;">
								<el-input v-model="elecInvoiceUploadFileName" placeholder="请选择文件" prefix-icon="el-icon-document" clearable style="width: 100%;"></el-input>
							</div>
							<div>
								<el-upload class="upload-demo" ref="elecUpload" :action="originalVoucherUploadUrl" :show-file-list="false" :on-change="invUploadFileChange" :auto-upload="false" :on-error="fileUploadError" :on-success="fileUploadSuccess" :data="uploadData">
									<el-button slot="trigger" plain>选择文件</el-button>
									<el-button size="small" type="primary" @click="invUploadClickFun" style="margin-left: 10px;width: 80px;"  :disabled="disabledElecUploadBtn">上传</el-button>
								</el-upload>
							</div>

						</div>
					</div>
					<el-row type="flex" style="padding: 10px 0px;" justify="space-between">
						<el-col :span="2">
							<el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
						</el-col>
						<el-col :span="6" style="text-align: right;">
							<el-input v-model="elecInvoiceUploadSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
						</el-col>
					</el-row>
					<el-table ref="elecInvoiceTable" :data="elecInvoiceTabelData" style="height:540px;" border stripe class="table" :default-sort="{ prop: 'uploadTime', order: 'descending'}" @row-click="(row) => clickRowByChecked('elecInvoiceTable', row)">
						<el-table-column type="selection" width="50"></el-table-column>
						<el-table-column prop="id" v-if="show == true"></el-table-column>
						<el-table-column prop="batchNo" label="批次号" sortable></el-table-column>
						<el-table-column prop="companyName" label="所属实体"></el-table-column>
						<el-table-column prop="fileName" label="原文档名称" sortable></el-table-column>
						<el-table-column prop="importWay" label="导入方式" width="150" sortable :formatter="this.formatImportWay"></el-table-column>
						<el-table-column prop="totalCount" label="文件总数" width="150" sortable></el-table-column>
						<el-table-column prop="successCount" label="上传成功数" width="150" sortable>
							<template slot-scope="scope">
								<el-link type="primary" @click="viewOriVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
							</template>
						</el-table-column>
						<el-table-column prop="failedCount" label="上传失败数" width="150" sortable></el-table-column>
						<el-table-column prop="message" label="失败详情" width="150" sortable>
							<template slot-scope="scope">
								<div v-if="scope.row.message && scope.row.message.length > 0">
									<el-link :href="downloadImportLogUrl + scope.row.id + '&' + token" :underline="false" type="primary" >下载日志</el-link>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="importTime" label="上传时间" sortable :formatter="(row, column, cellValue, index) => timestampSecondFormatter(cellValue)"></el-table-column>
						<el-table-column prop="operator" label="操作人" width="150" sortable></el-table-column>
					</el-table>
					<div class="pagination">
						<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="elecpwm.page"
							:page-size="elecpwm.limit"
							:page-sizes="elecpwm.limits"
							layout="total, sizes, prev, pager, next, jumper"
							:total="elecpwm.count">
						</el-pagination>
					</div>
				</el-tab-pane>
                <el-tab-pane label='海关缴款书上传' name='5'>
                    <el-row style='color:#909399;'>支持从本地导入海关缴款书原件，文件后缀类型包括：pdf以及包含前述后缀的zip文件</el-row>
                    <div class='m-bottom-border'>
                        <div style='display: flex;padding: 10px 0'>
                            <div style='display: flex;'>
                                <label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体</label>
                                <el-select v-model='paymentCompanyName' placeholder='请选择' style="width: 100%;margin-right: 30px;">
                                    <el-option
                                        v-for="item in paymentCompanyData"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div style="margin-right: 15px;">
                                <el-input v-model="paymentUploadFileName" placeholder="请选择文件" prefix-icon="el-icon-document" clearable style="width: 100%;"></el-input>
                            </div>
                            <div>
                                <el-upload class="upload-demo" ref="paymentUpload" :action="originalVoucherUploadUrl" :show-file-list="false" :on-change="invUploadFileChange" :auto-upload="false" :on-error="fileUploadError" :on-success="fileUploadSuccess" :data="uploadData">
                                    <el-button slot="trigger" plain>选择文件</el-button>
                                    <el-button size="small" type="primary" @click="invUploadClickFun" style="margin-left: 10px;width: 80px;"  :disabled="disabledPaymentUploadBtn">上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <el-row type="flex" style="padding: 10px 0px;" justify="space-between">
                        <el-col :span="2">
                            <el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
                        </el-col>
                        <el-col :span="6" style="text-align: right;">
                            <el-input v-model="paymentUploadSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
                        </el-col>
                    </el-row>
                    <el-table ref="paymentTable" :data="paymentTableData" style="height:540px;" border stripe class="table" :default-sort="{ prop: 'uploadTime', order: 'descending'}" @row-click="(row) => clickRowByChecked('paymentTable', row)">
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column prop="id" v-if="show == true"></el-table-column>
                        <el-table-column prop="batchNo" label="批次号" sortable></el-table-column>
                        <el-table-column prop="companyName" label="所属实体"></el-table-column>
                        <el-table-column prop="fileName" label="原文档名称" sortable></el-table-column>
                        <el-table-column prop="importWay" label="导入方式" width="150" sortable :formatter="this.formatImportWay"></el-table-column>
                        <el-table-column prop="totalCount" label="文件总数" width="150" sortable></el-table-column>
                        <el-table-column prop="successCount" label="上传成功数" width="150" sortable>
                            <template slot-scope="scope">
                                <el-link type="primary" @click="viewOriVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="failedCount" label="上传失败数" width="150" sortable></el-table-column>
                        <el-table-column prop="message" label="失败详情" width="150" sortable>
                            <template slot-scope="scope">
                                <div v-if="scope.row.message && scope.row.message.length > 0">
                                    <el-link :href="downloadImportLogUrl + scope.row.id + '&' + token" :underline="false" type="primary" >下载日志</el-link>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="importTime" label="上传时间" sortable :formatter="(row, column, cellValue, index) => timestampSecondFormatter(cellValue)"></el-table-column>
                        <el-table-column prop="operator" label="操作人" width="150" sortable></el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="paymentpwm.page"
                            :page-size="paymentpwm.limit"
                            :page-sizes="paymentpwm.limits"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="paymentpwm.count">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label='银行回单' name='6'>
                    <el-row style='color:#909399;'>支持从本地导入银行回单原件，文件后缀类型包括：jpg、jpeg、png、bmp以及包含前述后缀的zip文件</el-row>
                    <div class='m-bottom-border'>
                        <div style='display: flex;padding: 10px 0'>
                            <div style='display: flex;'>
                                <label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体</label>
                                <el-select v-model='bankReceiptCompanyName' placeholder='请选择' style="width: 100%;margin-right: 30px;">
                                    <el-option
                                        v-for="item in bankReceiptCompanyData"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div style="margin-right: 15px;">
                                <el-input v-model="bankReceiptUploadFileName" placeholder="请选择文件" prefix-icon="el-icon-document" clearable style="width: 100%;"></el-input>
                            </div>
                            <div>
                                <el-upload class="upload-demo" ref="bankReceiptUpload" :action="originalVoucherUploadUrl" :show-file-list="false" :on-change="invUploadFileChange" :auto-upload="false" :on-error="fileUploadError" :on-success="fileUploadSuccess" :data="uploadData">
                                    <el-button slot="trigger" plain>选择文件</el-button>
                                    <el-button size="small" type="primary" @click="invUploadClickFun" style="margin-left: 10px;width: 80px;"  :disabled="disabledOtherUploadBtn">上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <el-row type="flex" style="padding: 10px 0px;" justify="space-between">
                        <el-col :span="2">
                            <el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
                        </el-col>
                        <el-col :span="6" style="text-align: right;">
                            <el-input v-model="bankReceiptUploadSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
                        </el-col>
                    </el-row>
                    <el-table ref="bankReceiptTable" :data="bankReceiptTableData" style="height:540px;" border stripe class="table" :default-sort="{ prop: 'uploadTime', order: 'descending'}" @row-click="(row) => clickRowByChecked('bankReceiptTable', row)">
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column prop="id" v-if="show == true"></el-table-column>
                        <el-table-column prop="batchNo" label="批次号" sortable></el-table-column>
                        <el-table-column prop="companyName" label="所属实体"></el-table-column>
                        <el-table-column prop="fileName" label="原文档名称" sortable></el-table-column>
                        <el-table-column prop="importWay" label="导入方式" width="150" sortable :formatter="this.formatImportWay"></el-table-column>
                        <el-table-column prop="totalCount" label="文件总数" width="150" sortable></el-table-column>
                        <el-table-column prop="successCount" label="上传成功数" width="150" sortable>
                            <template slot-scope="scope">
                                <el-link type="primary" @click="viewOriVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="failedCount" label="上传失败数" width="150" sortable></el-table-column>
                        <el-table-column prop="message" label="失败详情" width="150" sortable>
                            <template slot-scope="scope">
                                <div v-if="scope.row.message && scope.row.message.length > 0">
                                    <el-link :href="downloadImportLogUrl + scope.row.id + '&' + token" :underline="false" type="primary" >下载日志</el-link>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="importTime" label="上传时间" sortable :formatter="(row, column, cellValue, index) => timestampSecondFormatter(cellValue)"></el-table-column>
                        <el-table-column prop="operator" label="操作人" width="150" sortable></el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="bankReceiptpwm.page"
                            :page-size="bankReceiptpwm.limit"
                            :page-sizes="bankReceiptpwm.limits"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="bankReceiptpwm.count">
                        </el-pagination>
                    </div>
                </el-tab-pane>
				<el-tab-pane label="其他凭证上传" name="3">
					<el-row style="color: #909399;">其他原始凭证上传，文件后缀类型包括：JPG/PNG/PDF/EML/EXCEL/WORD以及包含前述后缀的ZIP、7z文件。</el-row>
					<div  class="m-bottom-border">
						<div style="display: flex;padding: 10px 0px;" >
							<div style="display: flex;">
								<label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体</label>
								<el-select v-model="otherCompanyName" placeholder="请选择" style="width: 100%;margin-right: 30px;">
									<el-option
										v-for="item in otherCompanyData"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div style="margin-right: 15px;">
								<el-input v-model="otherVoucherUploadFileName" placeholder="请选择文件" prefix-icon="el-icon-document" clearable style="width: 100%;"></el-input>
							</div>
							<div>
								<el-upload class="upload-demo" ref="otherUpload" :action="originalVoucherUploadUrl" :show-file-list="false" :on-change="invUploadFileChange" :auto-upload="false" :on-error="fileUploadError" :on-success="fileUploadSuccess" :data="uploadData">
									<el-button slot="trigger" plain>选择文件</el-button>
									<el-button size="small" type="primary" @click="invUploadClickFun" style="margin-left: 10px;width: 80px;"  :disabled="disabledOtherUploadBtn">上传</el-button>
									<el-button size="small" type="primary" @click="invRelationUploadClickFun" style="margin-left: 10px;width:150px;" >关联记账凭证上传</el-button>
								</el-upload>
							</div>
						</div>
					</div>
					<el-row type="flex" style="padding: 10px 0px;" justify="space-between">
						<el-col :span="2">
							<el-button type="primary" style="width: 80px;" @click="deleteUploadDataClickFun">删除</el-button>
						</el-col>
						<el-col :span="6" style="text-align: right;">
							<el-input v-model="otherVoucherUploadSearchName" placeholder="批次号、原文档名称、操作人" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
						</el-col>
					</el-row>
					<el-table ref="otherVoucherTable" :data="otherVoucherTableData" style="height:540px;" border stripe class="table" :default-sort="{ prop: 'uploadTime', order: 'descending'}" @row-click="(row) => clickRowByChecked('otherVoucherTable', row)">
						<el-table-column type="selection" width="50"></el-table-column>
						<el-table-column prop="id" v-if="show == true"></el-table-column>
						<el-table-column prop="batchNo" label="批次号" sortable></el-table-column>
						<el-table-column prop="companyName" label="所属实体"></el-table-column>
						<el-table-column prop="fileName" label="原文档名称" sortable></el-table-column>
						<el-table-column prop="importWay" label="导入方式" width="150" sortable :formatter="this.formatImportWay"></el-table-column>
						<el-table-column prop="totalCount" label="文件总数" width="150" sortable></el-table-column>
						<el-table-column prop="successCount" label="上传成功数" width="150" sortable>
							<template slot-scope="scope">
								<el-link type="primary" @click="viewOriVoucherUploadDetail(scope.row)">{{ scope.row.successCount }}</el-link>
							</template>
						</el-table-column>
						<el-table-column prop="failedCount" label="上传失败数" width="150" sortable></el-table-column>
						<el-table-column prop="message" label="失败详情" width="150" sortable>
							<template slot-scope="scope">
								<div v-if="scope.row.message && scope.row.message.length > 0">
									<el-link :href="downloadImportLogUrl + scope.row.id + '&' + token" :underline="false" type="primary" >下载日志</el-link>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="importTime" label="上传时间" sortable :formatter="(row, column, cellValue, index) => timestampSecondFormatter(cellValue)"></el-table-column>
						<el-table-column prop="operator" label="操作人" width="150" sortable></el-table-column>
					</el-table>
					<div class="pagination">
						<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="otherpwm.page"
							:page-size="otherpwm.limit"
							:page-sizes="otherpwm.limits"
							layout="total, sizes, prev, pager, next, jumper"
							:total="otherpwm.count">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<el-dialog title="上传成功详情" :visible.sync="uploadViewDialogVisible" width="90%" class="dialog" :close-on-click-modal="false">
			<div class="custom-dialog">
				<el-row type="flex">
					<el-col :span="11">
						<el-card class="box-card" style="height: 600px;">
							<el-row style="padding-bottom: 10px;">
								<el-col :span="10">
									<el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;" @click="upRow"><i class="el-icon-arrow-up" style="font-size: 20px;font-weight: bold;"></i></el-button>
									<el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;" @click="downRow"><i class="el-icon-arrow-down" style="font-size: 20px;font-weight: bold;"></i></el-button>
								</el-col>
								<el-col :span="2">
									<span  style="margin-right:5px;text-align: center;" >
										<el-button style="font-size:12px;" size="small" type="text" @click="dowloadAllFile()">下载全部</el-button>
									</span>
								</el-col>
								<el-col :span="12" style="float: right;">
									<el-input v-model="svSearchName" :placeholder="originalVoucherPlaceHolder" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryOriginalVoucher"></el-input>
								</el-col>
							</el-row>
							<el-table ref="originalVoucherTable" :data="originalVoucherTableData" height="480px" border stripe class="table" @row-click="(row, column) => clickRowByChecked('originalVoucherTable', row, column)" :row-class-name="tableRowClassName">
								<el-table-column type="selection" width="50"></el-table-column>
								<el-table-column type="index" v-if="show == true"></el-table-column>
								<el-table-column prop="id" v-if="show == true"></el-table-column>
								<el-table-column prop="voucherType" label="凭证类型" align="center">
									<template slot-scope="scoped">
										<div v-for="(imgObj, index) in formatVoucherTypeImgList" :key="index">
											<img v-if="scoped.row.voucherType == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="voucherNo" label="凭证号码" sortable v-if="showColumn == false" align="center"></el-table-column>
								<el-table-column prop="voucherAmount" label="凭证金额" sortable v-if="showColumn == false" align="right" :formatter="(row, column, cellValue, index) => formatAmountSeparator(cellValue)"></el-table-column>
								<el-table-column prop="fileName" label="原文件名" sortable v-if="showFileNameColumn == false"></el-table-column>
								<el-table-column prop="fileStatus" label="人工验证" v-if="showColumn == false" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.fileStatus == '1'" style="text-align: center;">
											<i class="el-icon-check" style="color: #84b944;font-size: 20px;font-weight: bold;"></i>
										</div>
										<div v-else-if="scope.row.fileStatus == '2'" style="text-align: center;">
											<i class="el-icon-close" style="color: red;font-size: 20px;font-weight: bold;"></i>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="operate" label="操作" sortable width="150" align="center">
									<template slot-scope="scoped">
										<el-button size="small" type="text" @click="oriVoucherEditClickFun(scoped.row)" v-show="scoped.row.imageType=='1' || scoped.row.imageType == null">编辑</el-button>
										<span v-if="scoped.row.id && scoped.row.filePath.length > 0" style="margin-left:4px">
											<el-link style="font-size:12px;" :href="downloadFileUrl + scoped.row.id + '&' + token" 
												:underline="false" type="primary"  >下载文件</el-link>
										</span>
									</template>
								</el-table-column>
							</el-table>
							<div class="pagination">
								<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="oriVoucherRefresh()"></el-link>
								<el-pagination
									@size-change="handleSizeOriVoucherChange"
									@current-change="handleCurrentOriVoucherChange"
									:current-page="pwm.page"
									:page-size="pwm.limit"
									:page-sizes="pwm.limits"
									layout="total, sizes, prev, pager, next, jumper"
									:total="pwm.count">
								</el-pagination>
							</div>
						</el-card>
					</el-col>
					<el-col :span="13">
						<el-card class="box-card" style="height: 600px;margin-left:5px;">
							<div>
								<div id="viewText" style="display:none;" >
									该文件暂不支持预览,可选择下载预览。
								</div>
								<div id="voucherImgDiv" style="height: 590px;overflow: auto">
									<img id="voucherImg" src="" width="100%" height="auto" frameborder="no" scrolling="yes" style="overflow-y:scroll;">
								</div>
                                <iframe src="" id="oriv_pdf_frame" width="100%" height="590px" frameborder="no" scrolling="yes" style="overflow-y:scroll;display:none;"></iframe>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<el-dialog title="关联记账凭证文件上传" :visible.sync="disabledRelationOtherDialog" width="25%" class="dialog" :close-on-click-modal="false">
			<div class="custom-dialog" >
				<el-row type="flex">
					<el-col :span="24">
							<div style="display: flex;padding-top: 6%">
								<div style="width: 130px;margin-right: 5%;line-height: 37px;">
									<label style="color: #606266;"><span style="color: red;">*</span> 文件信息:</label>
								</div>
								<el-input v-model="otherVoucherUploadFileName" disabled="true" style="width: 300px;"></el-input>
							</div>
							<div style="display: flex;padding-top: 8px">
								<div style="width: 130px;margin-right: 5%;line-height: 37px;">
									<label style="color: #606266;"><span style="color: red;">*</span> 记账凭证号:</label>
								</div>
								<el-input v-model="uploadData.voucherNo" placeholder="多个记账凭证号请用','分隔" style="width: 300px;"></el-input>
							</div>
							<div style="display: flex;padding-top: 8px;">
								<div style="width: 130px;margin-right: 5%;line-height: 37px;">
									<label style="color: #606266;"><span style="color: red;">*</span> 财年:</label>
								</div>
								<el-input v-model="uploadData.year" style="width: 300px;"></el-input>
							</div>
							<div style="display: flex;margin-top: 20px;justify-content:flex-end;">
								<el-button size="small" type="primary" @click="relationVoucher" style="width:150px;" >关联记账凭证上传</el-button>
							</div>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<el-dialog v-dialogDrag title="原始凭证信息编辑" :visible.sync="oriVoucherEditDialogVisible" width="1150px" class="dialog" :close-on-click-modal="false">
			<div class="custom-dialog">
				<el-form :model="oriVoucherEditForm" ref="oriVoucherEditForm" :rules="oriVoucherEditFormRule" style="width: 98%;padding-left: 30px;">
					<el-input v-if="show == true" v-model="oriVoucherEditForm.id" id="hideId"></el-input>
					<div style="display: flex;padding-top: 10px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证类型</label>
						</div>
						<div class="voucher-img-div" v-for="(imgObj, index) in voucherTypeImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="voucherTypeImgClickFun($event, index)">
						</div>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证号码</label>
						</div>
						<el-form-item prop="voucherNo">
							<el-input v-model="oriVoucherEditForm.voucherNo" style="width: 300px;"></el-input>
						</el-form-item>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证金额</label>
						</div>
						<el-form-item prop="voucherAmount">
							<el-input v-model="oriVoucherEditForm.voucherAmount" type="number" style="width: 300px;"></el-input>
						</el-form-item>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证日期</label>
						</div>
						<el-form-item prop="voucherDate">
							<el-date-picker v-model="oriVoucherEditForm.invoiceDate" type="date" placeholder="凭证日期" format="yyyy年MM月dd日" value-format="yyyyMMdd" style="width: 300px;"></el-date-picker>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style="width: 80px;" @click="saveOriginalVoucherData()">保存</el-button>
				<el-button plain @click="oriVoucherEditDialogVisible = false" style="width: 80px;">返回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
export default {
	name: 'basetable',
	data() {
		return {
			invpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			elecpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			otherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
            paymentpwm:{
			    count: 0,
                limit: 10,
                page: 1,
                limits: [10, 20, 50, 100]
            },
            bankReceiptpwm:{
			    count: 0,
                limit: 10,
                page: 1,
                limits: [10, 20, 50, 100]
            },
			pwm: {	//	上传成功详情 dialog 分页参数
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			sourceVoucherTabs: '1', // 默认选中tab页
			show: false,
			disabledInvUploadBtn: false,
			disabledElecUploadBtn: false,
			disabledOtherUploadBtn: false,
			disabledPaymentUploadBtn: false,
			disabledBankReceiptUploadBtn: false,
			invCompanyName: '',
			einvCompanyName: '',
			otherCompanyName: '',
            paymentCompanyName: '',
            bankReceiptCompanyName: '',
			invCompanyData: [],
			einvCompanyData: [],
			otherCompanyData: [],
            paymentCompanyData: [],
            bankReceiptCompanyData: [],
			uploadData: {
				token: '',
				type: '',
				companyId: '',
				voucherNo:"",
				year:"",
			},
			invUploadUrl: '',
			invoiceUploadTableData: [],
			invUploadForm: {
				invoiceUploadFileName: ''
			},
			invoiceUploadSearchName: '',
			elecUploadUrl: '',
			elecInvoiceTabelData: [],
			elecInvoiceUploadFileName: '',
			elecInvoiceUploadSearchName: '',
			otherUploadUrl: '',
			otherVoucherTableData: [],
			paymentTableData: [],
			bankReceiptTableData: [],
			otherVoucherUploadFileName: '',
			paymentUploadFileName: '',
			bankReceiptUploadFileName: '',
			otherVoucherUploadSearchName: '',
			paymentUploadSearchName: '',
			bankReceiptUploadSearchName: '',
			downloadImportLogUrl: this.baseURL + '/archival/voucher/downloadImportLog?id=',
			//	查看当前批次上传成功信息 dialog
			originalVoucherUploadUrl: this.baseURL + '/archival/uploadOriginalVoucherFileV2',
			uploadViewDialogVisible: false,
			originalVoucherTableData: [],
			batchNo: '',	//	当前点击数据所在批次的批次号
			svSearchName: '',	// 搜索框
			originalVoucherPlaceHolder: '',	
			currentRowIndex: '',	//	当前 index
			showColumn: false,
			showFileNameColumn: false,
			//	原始凭证信息编辑
			oriVoucherEditDialogVisible: false,
			formatVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			voucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),	//	凭证类型
			downloadFileUrl: this.baseURL + '/dowload/dowloadOvFile?id=',
			downloadAllFileUrl:this.baseURL + '/dowload/dowloadAllFile?ids=',
			oriVoucherEditForm: {
				id: '',
				voucherNo: '',
				voucherAmount: '',
			},
			oriVoucherEditFormRule: {
				voucherNo: [
					{ required: true, message: '请输入凭证号码', trigger: 'blur' },
					{ max: 50, message: '凭证号码不得超过50个字符'}
				],
				voucherAmount: [
					{ required: true, message: '请输入凭证金额', trigger: 'blur' },
					// { validator(rule, value, callback) {
					// 	if(value.indexOf('.') != -1) {
					// 		let val = value.substr(value.indexOf('.') + 1);
					// 		if(val.length <= 2) {
					// 			return callback();
					// 		}
					// 		callback(new Error('小数点后最多输入两位'));
					// 	}
					// } }
				]
			},
			disabledRelationOtherDialog:false,
			oriVoucherRelationForm:{
				voucherNo:"",
				year:"",
			},
			token: 'token=' + localStorage.getItem('token')
		};
	},
	created: function() {
		this.getOriginalVoucherUploadData();
		this.getUserCheckCompanyListInfo();
	},
	methods: {
		refresh() {
			this.getOriginalVoucherUploadData();
		},
		oriVoucherRefresh() {
			this.getOriginalVoucherDataByBatchNo(this.batchNo);
		},
		handleSizeChange(val) {
			if(this.sourceVoucherTabs == '1') {
				this.invpwm.limit = val;
			} else if(this.sourceVoucherTabs == '2') {
				this.elecpwm.limit = val;
			} else if(this.sourceVoucherTabs == '3') {
				this.otherpwm.limit = val;
			} else if (this.sourceVoucherTabs == '5') {
			    this.paymentpwm.limit = val;
            } else if (this.sourceVoucherTabs == '6') {
			    this.bankReceiptpwm.limit = val;
            }
			this.getOriginalVoucherUploadData();
		},
		handleCurrentChange(val) {
			if(this.sourceVoucherTabs == '1') {
				this.invpwm.page = val;
			} else if(this.sourceVoucherTabs == '2') {
				this.elecpwm.page = val;
			} else if(this.sourceVoucherTabs == '3') {
				this.otherpwm.page = val;
			}else if (this.sourceVoucherTabs == '5') {
			    this.paymentpwm.page = val;
            }else if (this.sourceVoucherTabs == '6') {
			    this.bankReceiptpwm.page = val;
            }
			this.getOriginalVoucherUploadData();
		},
		handleSizeOriVoucherChange(val) {
			this.pwm.limit = val;
			this.getOriginalVoucherDataByBatchNo(this.batchNo);
		},
		async handleCurrentOriVoucherChange(val) {
			this.pwm.page = val;
			this.getOriginalVoucherDataByBatchNo(this.batchNo);
		},
		clickRowByChecked(refTableName, row, column) {
			if(refTableName == 'originalVoucherTable') {
				this.$refs.originalVoucherTable.clearSelection();
				this.currentRowIndex = row.rowIndex;

				//	切换图片
				if(column == undefined || column.property == undefined || (column.property && column.property != 'operate')) {
					this.showVoucherFile(row);
				}
			}
			this.$refs[refTableName].toggleRowSelection(row);
		},
		tableRowClassName({row, rowIndex}) {
			row.rowIndex = rowIndex;
		},
		upRow() {	//	dialog 查看凭证信息 table 行上翻
			let checkRows = this.$refs.originalVoucherTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行上翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			if(this.pwm.page == 1 && index == 0) {
				this.$message.error('当前已为第一个文件，无法上翻！');
				return;
			}
			let upData = [];
			if(index != 0) { //	非第一页第一条数据
				upData = this.originalVoucherTableData[index - 1];
				this.clickRowByChecked('originalVoucherTable', upData);
			} else {
				this.handleCurrentOriVoucherChange(this.pwm.page - 1);
				this.getOriginalVoucherDataByBatchNo(this.batchNo).then((val) => {
					upData = this.originalVoucherTableData[this.originalVoucherTableData.length - 1];
					this.clickRowByChecked('originalVoucherTable', upData);
				})
			}
			//	翻页查看凭证文件
			this.showVoucherFile(upData);
		},
		downRow() {	//	row 下翻
			let checkRows = this.$refs.originalVoucherTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行下翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			//	计算pageCount 分页总数
			let pageCount = Math.ceil(this.pwm.count / this.pwm.limit);
			if(this.pwm.page == pageCount && index == this.originalVoucherTableData.length - 1) {
				this.$message.error('当前已为最后一个文件，无法下翻！');
				return;
			} 
			let downData = [];
			if(index != this.originalVoucherTableData.length - 1) {	//	非当前页最后一条数据
				downData = this.originalVoucherTableData[index + 1];
				this.clickRowByChecked('originalVoucherTable', downData);
			} else {
				this.handleCurrentOriVoucherChange(this.pwm.page + 1);
				this.getOriginalVoucherDataByBatchNo(this.batchNo).then((val) => {
					downData = this.originalVoucherTableData[0];
					this.clickRowByChecked('originalVoucherTable', downData);
				});
			}
			//	翻页查看凭证文件
			this.showVoucherFile(downData);
		},
		async getUserCheckCompanyListInfo() { // 查询当前登录用户勾选公司
			fetchPost('/sys/main/getUserCheckCompanyList').then(res => {
				if (res.data.success) {
					let resData = res.data.obj;
					if(this.sourceVoucherTabs == '1') {
						this.invCompanyData = resData;
						if (resData && resData.length > 0) {
							this.invCompanyName = resData[0].id;
						}
					} else if(this.sourceVoucherTabs == '2') {
						this.einvCompanyData = resData;
						if (resData && resData.length > 0) {
							this.einvCompanyName = resData[0].id;
						}
					} else if(this.sourceVoucherTabs == '3') {
						this.otherCompanyData = resData;
						if (resData && resData.length > 0) {
							this.otherCompanyName = resData[0].id;
						}
					} else if (this.sourceVoucherTabs == '5') {
                        this.paymentCompanyData = resData;
                        if (resData && resData.length > 0) {
                            this.paymentCompanyName = resData[0].id;
                        }
                    } else if (this.sourceVoucherTabs == '6') {
                        this.bankReceiptCompanyData = resData;
                        if (resData && resData.length > 0) {
                            this.bankReceiptCompanyName = resData[0].id;
                        }
                    }
				} else {
					this.$message.error('加载勾选公司信息失败：' + res.data.message);
				}
			}, error => {
				this.$message.error('加载勾选公司信息失败：' + error);
			});
		},
		async getOriginalVoucherUploadData() {	//	获取原始凭证上传记录数据
			let pwm = {};
			this.getPageObj().then(data => {
				pwm = data;
				pwm.search = { 'type': this.sourceVoucherTabs };
				let searchName = "";
				if(this.sourceVoucherTabs == '1') {
					searchName = this.invoiceUploadSearchName;
				} else if(this.sourceVoucherTabs == '2') {
					searchName = this.elecInvoiceUploadSearchName;
				} else if(this.sourceVoucherTabs == '3') {
					searchName = this.otherVoucherUploadSearchName;
				} else if (this.sourceVoucherTabs == '5') {
                    searchName = this.paymentUploadSearchName;
                }else if (this.sourceVoucherTabs == '6') {
                    searchName = this.bankReceiptUploadSearchName;
                }
				pwm.likeSearch = searchName;

				fetchPost('/archival/getOriginalVoucherImportList', pwm).then(res => {
					this.loadTableData(res.data);
				}, error => {
					this.$message.error('加载上传信息失败：' + error);
				});
			});

		},
		async loadTableData(result) {
			if(this.sourceVoucherTabs == '1') {
				this.invoiceUploadTableData = result.data;
				this.invpwm.count = result.count;
			} else if(this.sourceVoucherTabs == '2') {
				this.elecInvoiceTabelData = result.data;
				this.elecpwm.count = result.count;
			} else if(this.sourceVoucherTabs == '3') {
				this.otherVoucherTableData = result.data;
				this.otherpwm.count = result.count;
			} else if (this.sourceVoucherTabs == '5') {
                this.paymentTableData = result.data;
                this.paymentpwm.count = result.count;
            } else if (this.sourceVoucherTabs == '6') {
                this.bankReceiptTableData = result.data;
                this.bankReceiptpwm.count = result.count;
            }
			this.clearUploadFileName();
		},
		async getPageObj() {
			let pwm = {};
			if(this.sourceVoucherTabs == '1') {
				pwm = this.invpwm;
			} else if(this.sourceVoucherTabs == '2') {
				pwm = this.elecpwm;
			} else if(this.sourceVoucherTabs == '3') {
				pwm = this.otherpwm;
			} else if (this.sourceVoucherTabs == '5') {
                pwm = this.paymentpwm;
            } else if (this.sourceVoucherTabs == '6') {
			    pwm = this.bankReceiptpwm;
            }
			return pwm;
		},
		async getOriginalVoucherDataByBatchNo(batchNo) {	//	点击上传成功数 查看本批次原始凭证数据
			this.pwm.likeSearch = this.svSearchName;
			this.pwm.search = { 'batchNo': batchNo, 'type': this.sourceVoucherTabs };
			await fetchPost('/archival/getOriginalVoucherListByBatchNo', this.pwm).then(res => {
				this.originalVoucherTableData = res.data.data;
				this.pwm.count = res.data.count;
			}, error => {
				this.$message.error('加载原始凭证信息失败：' + error);
			});
		},
		advanceQueryUploadData() {
			this.otherpwm.limit = 10;
			this.otherpwm.page = 1;
			this.getOriginalVoucherUploadData();
		},
		advanceQueryOriginalVoucher() {
			this.getOriginalVoucherDataByBatchNo(this.batchNo);
		},
		invUploadFileChange(file, fileList) {	//	常规发票上传 - change事件
			if(this.sourceVoucherTabs == '1') {
				this.invUploadForm.invoiceUploadFileName = file.name;
			} else if(this.sourceVoucherTabs == '2') {
				this.elecInvoiceUploadFileName = file.name;
			} else if(this.sourceVoucherTabs == '3') {
				this.otherVoucherUploadFileName = file.name;
			} else if (this.sourceVoucherTabs == '5') {
                this.paymentUploadFileName = file.name;
            } else if (this.sourceVoucherTabs == '6') {
                this.bankReceiptUploadFileName = file.name;
            }
			//	选择文件前清空之前上传的文件
			this.clearUploadFile(file, fileList);
			//	校验文件上传格式
			this.validUploadFileFormat(file).then(validFlag => {
				if(!validFlag) {
					if(this.sourceVoucherTabs == '1') {
						this.disabledInvUploadBtn = true;
					} else if(this.sourceVoucherTabs == '2') {
						this.disabledElecUploadBtn = true;
					} else if(this.sourceVoucherTabs == '3') {
						this.disabledOtherUploadBtn = true;
					} else if (this.sourceVoucherTabs == '5') {
					    this.disabledPaymentUploadBtn = true;
                    } else if (this.sourceVoucherTabs == '6') {
					    this.disabledBankReceiptUploadBtn = true;
                    }
				} else {
					if(this.sourceVoucherTabs == '1') {
						this.disabledInvUploadBtn = false;
					} else if(this.sourceVoucherTabs == '2') {
						this.disabledElecUploadBtn = false;
					} else if(this.sourceVoucherTabs == '3') {
						this.disabledOtherUploadBtn = false;
					} else if (this.sourceVoucherTabs == '5') {
                        this.disabledPaymentUploadBtn = false;
                    } else if (this.sourceVoucherTabs == '6') {
					    this.disabledBankReceiptUploadBtn = false;
                    }
				}
			});
		},
		async clearUploadFile(file, fileList) {	//	清空上传的文件
			let newFileList = fileList.filter(item => {
				if(item.uid == file.uid) {
					return true;
				} else {
					return false;
				}
			});
			if(this.sourceVoucherTabs == '1') {
				this.$refs.invUpload.uploadFiles = newFileList;
			} else if(this.sourceVoucherTabs == '2') {
				this.$refs.elecUpload.uploadFiles = newFileList;
			} else if(this.sourceVoucherTabs == '3') {
				this.$refs.otherUpload.uploadFiles = newFileList;
			} else if (this.sourceVoucherTabs == '5') {
                this.$refs.paymentUplaod.uploadFiles = newFileList;
            } else if (this.sourceVoucherTabs == '6') {
                this.$refs.bankReceiptUpload.uploadFiles = newFileList;
            }
		},
		 clearUploadFileName() {	//	清空上传的文件名称
			if(this.sourceVoucherTabs == '1') {
				this.invUploadForm.invoiceUploadFileName = "";
				this.$refs.invUpload.clearFiles();
			} else if(this.sourceVoucherTabs == '2') {
				this.elecInvoiceUploadFileName = "";
				this.$refs.elecUpload.clearFiles();
			} else if(this.sourceVoucherTabs == '3') {
				this.otherVoucherUploadFileName = "";
				this.$refs.otherUpload.clearFiles();
			}else if (this.sourceVoucherTabs == '5') {
                this.paymentUploadFileName = '';
                this.$refs.paymentUpload.clearFiles();
            }else if (this.sourceVoucherTabs == '6') {
                this.bankReceiptUploadFileName = '';
                this.$refs.bankReceiptUpload.clearFiles();
            }
		},
		async validUploadFileFormat(file) {	//	校验上传文件格式
			let fileType = file.name.substr(file.name.lastIndexOf('.') + 1);
			let uploadFormatArr = [];
			if(this.sourceVoucherTabs == '1') {
				uploadFormatArr = ['jpg', 'png', 'zip'];
			} else if(this.sourceVoucherTabs == '2') {
				uploadFormatArr = ['pdf', 'ofd', 'zip'];
			} else if(this.sourceVoucherTabs == '3') {
				uploadFormatArr = ['jpg', 'png', 'pdf', 'xls','xlsx','doc','docx','7z','zip','eml'];
			} else if (this.sourceVoucherTabs == '5') {
                uploadFormatArr = ['pdf', 'zip'];
            } else if (this.sourceVoucherTabs == '6') {
                uploadFormatArr = ['jpg', 'jpeg', 'png', 'bmp', 'zip'];
            }
			if(!uploadFormatArr.includes(fileType.toLowerCase())) {
				this.$message.error('文件格式校验失败，请重新上传！');
				return false;
			}
			return true;
		},
		invUploadClickFun() {	//	文件上传
			this.uploadData.type = this.sourceVoucherTabs;
			this.uploadData.token = localStorage.getItem('token');
			if(this.sourceVoucherTabs == '1') {
				if(!this.invUploadForm.invoiceUploadFileName || !this.$refs.invUpload.uploadFiles || this.$refs.invUpload.uploadFiles.length == 0) {
					this.$message.error('请选择需要上传的文件！');
					return;
				}
				if(!this.invCompanyName) {
					this.$message.error('请选择所属实体！');
					return;
				}
				//	校验上传的文件大小不得超过50M
				this.validUploadFileLimitSize(this.$refs.invUpload.uploadFiles).then(res => {
					if(res) {
						this.uploadData.companyId = this.invCompanyName;
						this.$refs.invUpload.submit();
					}
				});

			} else if(this.sourceVoucherTabs == '2') {
				if(!this.elecInvoiceUploadFileName || !this.$refs.elecUpload.uploadFiles || this.$refs.elecUpload.uploadFiles.length == 0) {
					this.$message.error('请选择需要上传的文件！');
					return;
				}
				if(!this.einvCompanyName) {
					this.$message.error('请选择所属实体！');
					return;
				}
				//	校验上传的文件大小不得超过50M
				this.validUploadFileLimitSize(this.$refs.elecUpload.uploadFiles).then(res => {
					if(res) {
						this.uploadData.companyId = this.einvCompanyName;
						this.$refs.elecUpload.submit();
					}
				});
			} else if(this.sourceVoucherTabs == '3') {
				if(!this.otherVoucherUploadFileName || !this.$refs.otherUpload.uploadFiles || this.$refs.otherUpload.uploadFiles.length == 0) {
					this.$message.error('请选择需要上传的文件！');
					return;
				}
				if(!this.otherCompanyName) {
					this.$message.error('请选择所属实体！');
					return;
				}
				//	校验上传的文件大小不得超过50M
				this.validUploadFileLimitSize(this.$refs.otherUpload.uploadFiles).then(res => {
					if(res) {
						this.uploadData.companyId = this.otherCompanyName;
						this.$refs.otherUpload.submit();
					}
				});
			}else if (this.sourceVoucherTabs == '5') {
                if (!this.paymentUploadFileName || !this.$refs.paymentUpload.uploadFiles || this.$refs.paymentUpload.uploadFiles.length == 0) {
                    this.$message.error('请选择需要上传的文件！');
                    return;
                }
                if (!this.paymentCompanyName) {
                    this.$message.error('请选择所属实体！');
                    return;
                }
                this.validUploadFileLimitSize(this.$refs.paymentUpload.uploadFiles).then(res=>{
                    if (res) {
                        this.uploadData.companyId = this.paymentCompanyName;
                        this.$refs.paymentUpload.submit();
                    }
                })
            }else if (this.sourceVoucherTabs == '6') {
                if (!this.bankReceiptUploadFileName || !this.$refs.bankReceiptUpload.uploadFiles || this.$refs.bankReceiptUpload.uploadFiles.length == 0) {
                    this.$message.error('请选择需要上传的文件！');
                    return;
                }
                if (!this.bankReceiptCompanyName) {
                    this.$message.error('请选择所属实体!');
                    return;
                }
                this.validUploadFileLimitSize(this.$refs.bankReceiptUpload.uploadFiles).then(res=>{
                    if (res) {
                        this.uploadData.companyId = this.bankReceiptCompanyName;
                        this.$refs.bankReceiptUpload.submit();
                    }
                })
            }
		},
		async validUploadFileLimitSize(uploadFiles) {	//	校验上传文件大小：不得超过50M
			let uploadFileSize = uploadFiles[0].size/(1024*1024);
			if(uploadFileSize > this.uploadFileLimitSize) {
				this.$message.error('上传失败：上传文件大小不得超过50M！');
				return false;
			}
			return true
		},
		fileUploadSuccess(res, file, fileList) {
			if(res.success) {
				this.$message.success('正在上传，请刷新查看上传结果！');
				this.getOriginalVoucherUploadData();
			} else {
				this.$message.error('文件上传失败：' + res.message);
			}
		},
		fileUploadError(error, file, fileList) {
			this.$message.error('文件上传失败：' + error);
		},
		deleteUploadDataClickFun() {
			let idList = [];
			let type = this.sourceVoucherTabs;
			let checkRows = [];
			if(type == '1') {
				checkRows = this.$refs.invoiceUploadTable.selection;
			} else if(type == '2') {
				checkRows = this.$refs.elecInvoiceTable.selection;
			} else if(type == '3') {
				checkRows = this.$refs.otherVoucherTable.selection;
			} else if (type == '5') {
                checkRows = this.$refs.paymentTable.selection;
            } else if (type == '6') {
			    checkRows = this.$refs.bankReceiptTable.selection;
            }
			if(!checkRows || checkRows.length == 0) {
				this.$message.warning('请选择需要删除的上传信息！');
				return;
			}
			checkRows.forEach(row => {
				idList.push(row.id);
			});
			let ids = idList.join(',');
			this.$confirm('是否删除当前选中的上传信息？', '提示', { type: 'warning'}).then(res => {
				fetchPost('/archival/deleteOriginalVoucherUploadData', ids).then(res => {
                    if(res.data.success) {
                        this.$message.success('删除成功！');
                        //  reload table
                        this.getOriginalVoucherUploadData();
                    } else {
                        this.$message.error('删除失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('删除失败：' + error);
                });
			});
		},
		viewOriVoucherUploadDetail(rowData) {	//	上传成功数点击 dialog
			if(!rowData || rowData.successCount == 0) {
				return;
			}
			if(this.sourceVoucherTabs == '1' || this.sourceVoucherTabs == '2') {
				this.showColumn = false;
				this.showFileNameColumn = true;
				this.originalVoucherPlaceHolder = '凭证号码、凭证金额';
			} else if (this.sourceVoucherTabs == '5' || this.sourceVoucherTabs == '6') {
			    this.showColumn = false;
			    this.showFileNameColumn = false;
                this.originalVoucherPlaceHolder = '凭证号码、凭证金额、原文件名';
            } else {
                this.showColumn = true;
                this.showFileNameColumn = false;
                this.originalVoucherPlaceHolder = '原文件名';
            }
			this.svSearchName = "";
			this.uploadViewDialogVisible = true;
			this.batchNo = rowData.batchNo;
			this.getOriginalVoucherDataByBatchNo(rowData.batchNo).then((val) => {
				if(this.originalVoucherTableData && this.originalVoucherTableData.length > 0) {
					let firstOriVoucherData = this.originalVoucherTableData[0];
					//	默认选中第一条数据
					this.clickRowByChecked('originalVoucherTable', firstOriVoucherData);
				}
			});
		},
		showVoucherFile(voucherData) {	//	显示凭证文件
			let fileName = voucherData.fileName;
			let fileType = fileName.substr(fileName.lastIndexOf('.') + 1);
			let image = document.getElementById("voucherImg");
			let imageDiv = document.getElementById("voucherImgDiv");
			let iframe = document.getElementById('oriv_pdf_frame');
			let viewText = document.getElementById('viewText');
			let tokenParam = "&token=" + localStorage.getItem('token');
			if(fileType.toLowerCase() == 'jpg' || fileType.toLowerCase() == 'png' || fileType.toLowerCase() == "jpeg") {
				imageDiv.style = "display:block";
				image.style = "display:block";
				iframe.style = "display:none";
				image.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + voucherData.id + tokenParam;
				viewText.style = "display:none";
			} else if(fileType.toLowerCase() == 'pdf') {
				imageDiv.style = "display:none";
				image.style = "display:none";
				iframe.style = "display:block";
				iframe.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + voucherData.id + tokenParam;
				viewText.style = "display:none";
			} else if(fileType.toLowerCase() == 'ofd') {
				imageDiv.style = "display:none";
				image.style = "display:none";
				iframe.style = "display:block";
				iframe.src = this.ofdReaderPath + '/ofd/reader?file=' + this.baseURL + "/archival/getOriginalVoucherDataById?id="+voucherData.id + "%26token=" + localStorage.getItem("token");
				viewText.style = "display:none";
			} else {
				viewText.style = "height: 590px;overflow: auto;color:red;font-size:25px;text-align:center;display:block";
				return;
			}
		},
		oriVoucherEditClickFun(rowData) {
			Object.keys(this.oriVoucherEditForm).map(key => (this.oriVoucherEditForm[key] = ''));

			//	人工验证通过的数据不允许凭证编辑
			if(rowData.fileStatus == '1') {
				this.$message.warning('凭证审核通过的数据，不支持编辑信息！');
				return;
			}

			//	默认选中凭证类型
			this.voucherTypeImgList = JSON.parse(JSON.stringify(this.originalvoucherTypeList));
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.code != rowData.voucherType) {
					item.name = item.name + "-h";
				}
			});
			this.oriVoucherEditForm = JSON.parse(JSON.stringify(rowData));
            console.log(JSON.stringify(rowData));
			this.oriVoucherEditDialogVisible = true;
		},
		voucherTypeImgClickFun(event, index) {	//	凭证类型点击选中/取消选中效果
			//	每次仅一种凭证类型被选中
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.name.lastIndexOf('-h') == -1) {
					item.name = item.name + '-h';
				} else {
					if((item.name.lastIndexOf('-h') + 2) != item.name.length) {
						item.name = item.name + '-h';
					}
				}
			});
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				voucherTypeImgList[index].name = imgName + '-h';
			} else {
				voucherTypeImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}
			console.log(JSON.stringify(this.voucherTypeImgList));
		},
		saveOriginalVoucherData() {	//	保存原始凭证数据
			let voucherData = this.oriVoucherEditForm;
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.name.lastIndexOf('-h') + 2 != item.name.length) {
					voucherData.voucherType = item.code;
				}
			});
			console.log(JSON.stringify(voucherData));
			this.$refs['oriVoucherEditForm'].validate((valid) => {
				console.log(valid)
				if (valid) {
					fetchPost('/archival/saveOriginalVoucherData', voucherData).then(res => {
					if(res.data.success) {
						this.$message.success('保存原始凭证信息成功！');
						this.oriVoucherEditDialogVisible = false;
						this.getOriginalVoucherDataByBatchNo(this.batchNo);
						} else {
							this.$message.error('保存原始凭证信息失败：' + res.data.message);
						}
					}, error => {
						this.$message.error('保存原始凭证信息失败：' + error);
					});	
				} else {
					console.log("失败")
					return false;
				}
			});
		},
		dowloadAllFile(){
			//选中cell
			let idList = [];
			let type = this.sourceVoucherTabs;
			let checkRows = this.$refs.originalVoucherTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.warning('请选择需要下载的凭证信息！');
				return;
			}
			checkRows.forEach(row => {
				console.log(row)
				idList.push(row.id);
			});
			let ids = idList.join(',');
			//下载选中的：
			location.href= this.downloadAllFileUrl+ids+ '&token=' + localStorage.getItem("token");
		},
		invRelationUploadClickFun(){
			this.disabledRelationOtherDialog= true;
		},
		relationVoucher(){
			this.uploadData.type = this.sourceVoucherTabs;
			this.uploadData.token = localStorage.getItem('token');
			if((this.uploadData.voucherNo == null && this.uploadData.year!=null) || (this.uploadData.voucherNo != null && this.uploadData.year == null)){
				this.$message.error('请完善对应的信息');
				return;
			}
			if(!this.otherVoucherUploadFileName || !this.$refs.otherUpload.uploadFiles || this.$refs.otherUpload.uploadFiles.length == 0) {
					this.$message.error('请选择需要上传的文件！');
					return;
				}
				if(!this.otherCompanyName) {
					this.$message.error('请选择所属实体！');
					return;
				}
				//	校验上传的文件大小不得超过50M
				this.validUploadFileLimitSize(this.$refs.otherUpload.uploadFiles).then(res => {
					if(res) {
						this.uploadData.companyId = this.otherCompanyName;
						this.$refs.otherUpload.submit();
					}
				});
				this.disabledRelationOtherDialog= false;
				this.getOriginalVoucherUploadData();

		}



	},
	watch: {
		'sourceVoucherTabs': function(val) {	//	监听 tab change事件
			this.getOriginalVoucherUploadData();
			this.getUserCheckCompanyListInfo();
		}
	}
};
</script>

<style scoped>
	.el-dialog {
		margin: 0 auto !important;
	}
	.el-dialog__header {
		padding: 0 !important;
	}

	.el-dialog__wrapper {
		display: flex ;
		align-items: center ;
		
	}
	/* /deep/ .el-upload--text {
		width: 85px;
		height: 35px;
	} */

	.item {
		display: flex;
		align-items: center;
	}
	.fle1 {
		display: flex;
	}

	/* /deep/ .el-form-item--small {
		margin-left: 20px;
	}
	/deep/.el-input {
		width: 150px;
	} */
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}
	.table {
		width: 100%;
		font-size: 14px;
	}
	.red {
		color: #ff0000;
	}
	.mr10 {
		margin-right: 10px;
	}
	.container /deep/.el-tabs__header {
		margin-bottom: 8px;
	}
	/* upload 文件上传组件 */
	.container /deep/ .el-upload {
		display: inline;
	}
	.container /deep/ .el-upload--text {
		border: none !important;
		border-radius: 0px !important;
		width: 80px;
		height: 32px;
	}
</style>
